import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MashoManagerModalService {

  private selectedMashoSubject = new BehaviorSubject<any>(null);
  public selectedMasho$ = this.selectedMashoSubject.asObservable();

  private preSelectedVehicleSubject = new BehaviorSubject<any>(null);
  public preSelectedVehicle$ = this.preSelectedVehicleSubject.asObservable();

  constructor() { }

  setSelectedMasho(masho: any): void {
    this.selectedMashoSubject.next(masho);
  }

  getSelectedMasho(): any | null {
    return this.selectedMashoSubject.value;
  }

  clearSelectedMasho(): void {
    this.selectedMashoSubject.next(null);
  }

  setPreSelectedVehicle(vehicle: any): void {
    this.preSelectedVehicleSubject.next(vehicle);
  }

  getPreSelectedVehicle(): any | null {
    return this.preSelectedVehicleSubject.value;
  }

  clearPreSelectedVehicle(): void {
    this.preSelectedVehicleSubject.next(null);
  }
}
